import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertBell20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0001 0.250061C6.54833 0.250061 3.7501 3.04828 3.7501 6.50006V9.12763C3.7501 10.6601 2.54365 11.7939 1.66338 12.9257C0.769321 14.0752 1.58848 15.7501 3.04474 15.7501H6.75C6.75 17.6064 8.03518 19.25 10 19.25C11.9648 19.25 13.25 17.6064 13.25 15.7501H16.9555C18.4117 15.7501 19.2309 14.0752 18.3368 12.9257C17.4566 11.7939 16.2501 10.6601 16.2501 9.12763V6.50006C16.2501 3.04828 13.4519 0.250061 10.0001 0.250061ZM11.75 15.7501H8.25C8.25 16.7841 8.85621 17.75 10 17.75C11.1438 17.75 11.75 16.7841 11.75 15.7501ZM5.2501 6.50006C5.2501 3.87671 7.37675 1.75006 10.0001 1.75006C12.6235 1.75006 14.7501 3.87671 14.7501 6.50006V9.12763C14.7501 11.0627 16.0377 12.4129 17.1528 13.8466C17.2805 14.0108 17.1635 14.2501 16.9555 14.2501H3.04474C2.83671 14.2501 2.71968 14.0108 2.84741 13.8466C3.96246 12.4129 5.2501 11.0627 5.2501 9.12763V6.50006Z'
      fill='currentColor'
    />
  </Svg>
);

AlertBell20.displayName = 'AlertBell20';
export default AlertBell20;
